import { Injectable } from '@angular/core';
import { ApiService } from '../../api/api.service';
import { apiUrls } from '../../../config/api/api-urls.config';
import { BugReportsResultsResponse } from '../../../models/bug-reports/responses/api-bug-reports-results-response.model';
import { BugReportsOpenCountResponse } from '../../../models/bug-reports/responses/api-bug-reports-open-count-response.model';

@Injectable({
  providedIn: 'root'
})
export class ApiBugReportsService {

  constructor(private apiService: ApiService) { }

  getReports(page: number, resultCount: number): Promise<BugReportsResultsResponse> {
    return new Promise<BugReportsResultsResponse>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(
        apiUrls.bugReportsGetReportsUrl,
        { page, result_count: resultCount },
        BugReportsResultsResponse
      ).then(
        (data: BugReportsResultsResponse) => { resolve(data); },
        error => { reject(error); }
      );
    });
  }

  getReportsOpenCount(): Promise<BugReportsOpenCountResponse> {
    return new Promise<BugReportsOpenCountResponse>((resolve, reject) => {
      this.apiService.launchAdminApiRequestGet(
        apiUrls.bugReportsGetReportsOpenCountUrl,
        BugReportsOpenCountResponse
      ).then(
        (data: BugReportsOpenCountResponse) => { resolve(data); },
        error => { reject(error); }
      );
    });
  }

  changeReportState(bugReportId: number, isClosed: boolean): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      this.apiService.launchAdminApiRequestPost(
        apiUrls.bugReportsChangeReportStateUrl,
        { bug_report_id: bugReportId, is_closed: isClosed }
      ).then(
        () => { resolve(); },
        error => { reject(error); }
      );
    });
  }
}
